<kt-base-modal [title]="'Scan Area'">
  <div modal-body>
    <div class="row">
      <div class="col-md-12 form-group">                  
        <kt-select [field]="formConstants.area_id" [form]="scanAreaForm" [options]="lookup.area" >                  
        </kt-select>                  
      </div>                  
    </div>                  
    <div class="modal-footer justify-content-between"> 
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">                  
      </kt-button>                    
      <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="saveClickHandler()">                  
      </kt-button>                  
    </div>
  </div>
</kt-base-modal>